import { useShallow } from "zustand/react/shallow";
import { RegulifyService } from "../api/RegulifyService";
import { useLoading } from "../context/LoadingContext";
import { useFDAChangeManagementStore } from "../store/useFDAChangeManagementStore";
import { questions } from "../utils/Questions";
import { useDownloadBase64File } from "./useDownloadBase64";

export function useFDAChangeManagementFlow() {
  const newDecisionFlowItem = useFDAChangeManagementStore(
    (state) => state.newDecisionFlowItem,
  );
  const setSelectedQuestion = useFDAChangeManagementStore(
    (state) => state.setSelectedQuestion,
  );
  const removeDecisionFlowItem = useFDAChangeManagementStore(
    (state) => state.removeDecisionFlowItem,
  );
  const resetDecisionFlowItem = useFDAChangeManagementStore(
    (state) => state.resetDecisionFlowItem,
  );
  const newQuestionMessage = useFDAChangeManagementStore(
    (state) => state.newQuestionMessage,
  );
  const selectedQuestion = useFDAChangeManagementStore(
    useShallow((state) => state.selectedQuestion),
  );
  const downloadBase64File = useDownloadBase64File();

  const { setLoading } = useLoading();

  const answerQuestion = async (question) => {
    try {
      if (question.ask) {
        const userMessage = {
          text: question.ask,
          sender: "Human",
        };
        newQuestionMessage(userMessage);
      }
      setLoading(true);
      const response = await RegulifyService.changeclarity_start_fda_change_flow(
        question.question.code,
        question.answer,
        question.ask ? question.ask : "",
      );

      if (response.status === 201 && response.data) {
        if (response.data.next_question_id === "Finish") {
          downloadBase64File(
            "application/pdf",
            response.data.pdf_base64,
            "change_management.pdf",
          );
          resetDecisionFlowItem();
        } else {
          if (question.ask) {
            const botMessage = {
              text: response.data.llm_answer,
              sender: "Bot",
            };
            newQuestionMessage(botMessage);
          } else {
            setSelectedQuestion(
              questions.find(
                (item) => item.code === response.data.next_question_id,
              ),
            );
            newDecisionFlowItem({
              question: question.question,
              answer: question.answer,
            });
          }
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setLoading(false);
  };

  const undoAnswerQuestion = async (code) => {
    try {
      setLoading(true);
      const response = await RegulifyService.changeclarity_start_fda_change_flow(
        selectedQuestion.code,
        "back",
      );

      if (response.status === 201 && response.data) {
        removeDecisionFlowItem();
        setSelectedQuestion(
          questions.find(
            (item) => item.code === response.data.next_question_id,
          ),
        );
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setLoading(false);
  };

  const resetFlow = async (code) => {
    try {
      setLoading(true);
      const response =
        await RegulifyService.changeclarity_reset_fda_change_flow();
      if (response.status === 201) {
        resetDecisionFlowItem();
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setLoading(false);
  };
  return [answerQuestion, undoAnswerQuestion, resetFlow];
}
